import { Button, ButtonVariant, ButtonSize } from "@repo/design-system/components/ui";
import PropTypes from "prop-types";
import { memo, useMemo } from "react";
import "./ButtonGroup.scss";


const DEFAULT_PRIMARY_BUTTON = {
    label: 'Save',
    className: "",
    variant: ButtonVariant.PRIMARY,
    size: ButtonSize.MD,
    rightIcon: "",
    leftIcon: ""
};
const DEFAULT_SECONDARY_BUTTON = {
    label: 'Cancel',
    className: "",
    variant: ButtonVariant.SECONDARY,
    size: ButtonSize.MD,
    rightIcon: "",
    leftIcon: ""
};

const ButtonGroupComponent = ({
    loading = false, sectionClass = "",
    primaryBtnObj, secondaryBtnObj
}) => {

    const primaryButton = useMemo(
        () => ({ ...DEFAULT_PRIMARY_BUTTON, ...primaryBtnObj }),
        [primaryBtnObj]
    );

    const secondaryButton = useMemo(
        () => ({ ...DEFAULT_SECONDARY_BUTTON, ...secondaryBtnObj }),
        [secondaryBtnObj]
    );

    return (
        <div className={`button-group-part ${sectionClass}`}>
            <Button loading={loading} variant={primaryButton.variant} size={primaryButton.size}
                className={primaryButton.className} onClick={primaryButton.onClick}
                disabled={primaryButton.disabled} rightIcon={primaryButton.rightIcon} leftIcon={primaryButton.leftIcon}>
                {primaryButton.label}
            </Button>

            <Button variant={secondaryButton.variant} size={secondaryButton.size}
                className={secondaryButton.className} onClick={secondaryButton.onClick}
                disabled={loading} rightIcon={secondaryButton.rightIcon}
                leftIcon={secondaryButton.leftIcon}>
                {secondaryButton.label}
            </Button>
        </div>
    );
};

ButtonGroupComponent.propTypes = {
    loading: PropTypes.bool,
    sectionClass: PropTypes.string,
    primaryBtnObj: PropTypes.shape({
        label: PropTypes.string,
        onClick: PropTypes.func,
        variant: PropTypes.string,
        disabled: PropTypes.bool
    }),
    secondaryBtnObj: PropTypes.shape({
        label: PropTypes.string,
        onClick: PropTypes.func,
        variant: PropTypes.string
    }),
};

export const ButtonGroup = memo(ButtonGroupComponent);